import { Reveal, SectionLabel } from "../components/Reveal";
import { IMG, STATS } from "../data/content";

const VALUES = [
  { t: "Craftsmanship", d: "Every joint, finish and fixture is executed by artisans who obsess over detail." },
  { t: "Transparency", d: "Package-based pricing means you always know what you pay for — no hidden costs." },
  { t: "Sustainability", d: "We favour responsibly-sourced materials and energy-conscious design." },
  { t: "On-time Delivery", d: "Disciplined project management keeps your build on schedule, every time." },
];

export default function About() {
  return (
    <div className="pt-32">
      <section className="max-w-7xl mx-auto px-6">
        <Reveal><SectionLabel>Our Story</SectionLabel></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif-display text-5xl md:text-6xl mt-6 max-w-3xl leading-tight">
            Rooted in tradition, built for tomorrow.
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-2xl text-lg text-muted-foreground leading-relaxed">
            Kalpavriksha Interiors & Constructions was founded on a simple belief — that a home should
            fulfil the aspirations of the people who live in it. Like the divine wish-granting tree we
            are named after, we exist to bring those wishes to life through design and craft.
          </p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 mt-16 grid lg:grid-cols-2 gap-6">
        <Reveal><img src={IMG.living1} alt="Interior" className="rounded-3xl w-full h-full object-cover aspect-[16/11]" /></Reveal>
        <Reveal delay={0.1}><img src={IMG.living4} alt="Interior" className="rounded-3xl w-full h-full object-cover aspect-[16/11]" /></Reveal>
      </section>

      {/* CEO */}
      <section className="max-w-7xl mx-auto px-6 py-24">
        <Reveal className="max-w-3xl">
          <SectionLabel>Leadership</SectionLabel>
          <h2 className="font-serif-display text-4xl md:text-5xl mt-5">A word from our CEO</h2>
          <p className="mt-6 text-muted-foreground leading-relaxed text-lg italic">
            "We don't just build interiors — we build trust. Every project carries my personal promise
            of quality, honesty and care. That is the Kalpavriksha way."
          </p>
          <p className="mt-6 font-serif-display text-2xl">Karthik Sharma</p>
          <p className="label-caps text-accent">Founder & CEO</p>
        </Reveal>
      </section>

      {/* STATS */}
      <section className="bg-secondary/40 border-y border-border">
        <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08} className="text-center">
              <p className="font-serif-display text-5xl text-accent">{s.value}</p>
              <p className="label-caps text-muted-foreground mt-2">{s.label}</p>
            </Reveal>
          ))}
        </div>
      </section>

      {/* VALUES */}
      <section className="max-w-7xl mx-auto px-6 py-24">
        <Reveal><SectionLabel>What We Value</SectionLabel></Reveal>
        <h2 className="font-serif-display text-4xl md:text-5xl mt-5 mb-14">Principles we build on</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {VALUES.map((v, i) => (
            <Reveal key={v.t} delay={i * 0.07}>
              <div className="hover-lift h-full rounded-2xl border border-border bg-card p-8">
                <span className="font-serif-display text-5xl text-accent/30">0{i + 1}</span>
                <h3 className="font-serif-display text-2xl mt-3">{v.t}</h3>
                <p className="mt-3 text-muted-foreground leading-relaxed">{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
